module.exports = __webpack_public_path__ + "img/Cuckoo Express.817dca50.png";